import { FC, useEffect, useState } from "react";
import { CSSProperties } from "styled-components";
import { loadImage } from "../store";
import { useInView } from "react-intersection-observer";

const Image: FC<{
    alt: string;
    className?: string;
    style?: CSSProperties;
    fileId?: string;
    contentUrl?: string;
}> = ({ alt, className, style, fileId, contentUrl }) => {
    const [src, setSrc] = useState<string | undefined>(undefined);
    const { ref, inView } = useInView({ triggerOnce: true, rootMargin: "100px" });

    useEffect(() => {
        let isCancelled = false;
        let url: string | undefined;

        async function fetchImage() {
            if (!inView) return;

            if (fileId) {
                const blob = await loadImage(fileId);
                if (!blob || isCancelled) return;
                url = URL.createObjectURL(blob);
                setSrc(url);
            } else {
                setSrc(contentUrl);
            }
        }

        fetchImage();

        return () => {
            isCancelled = true;
            if (url) {
                URL.revokeObjectURL(url);
            }
        };
    }, [fileId, contentUrl, inView]);

    return (
        <img
            ref={ref}
            className={className}
            src={src}
            alt={alt}
            loading="lazy"
            style={style}
        />
    );
};

export default Image;
